import { render, staticRenderFns } from "./MultiplayerTinySetting.vue?vue&type=template&id=7d396796&scoped=true&lang=pug&"
import script from "./MultiplayerTinySetting.vue?vue&type=script&lang=js&"
export * from "./MultiplayerTinySetting.vue?vue&type=script&lang=js&"
import style0 from "./MultiplayerTinySetting.vue?vue&type=style&index=0&id=7d396796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d396796",
  null
  
)

export default component.exports